import React from 'react'
import { Link } from 'gatsby'
import {
  DropDownWrapper,
  DropDownInner,
  ButtonWrapper,
  Text,
} from './DropDown.styles'

import { Fade } from 'react-reveal'
import { v4 as uuidv4 } from 'uuid'

const DropDown = ({ dropDownItems, button }) => {
  return (
    <DropDownWrapper>
      <Fade cascade right distance="300px">
        <DropDownInner>
          {dropDownItems.map((item) => (
            <Link
              key={uuidv4()}
              to={item.slug}
              activeClassName="DropDown-active"
            >
              {item.icon}
              <h3>{item.head}</h3>
              <Text paragraphMax={item.paragraphMax}>{item.sub}</Text>
            </Link>
          ))}
        </DropDownInner>
      </Fade>

      {button && <ButtonWrapper>{button}</ButtonWrapper>}
    </DropDownWrapper>
  )
}

export default DropDown
